import React, { useState } from 'react';
import { _$, _addClass } from '../../../../controllers/dom'; // , , _removeClass, _setText
import { NotificationManager } from 'react-notifications';
import { locales } from '../../../../translations/locales';
import { BsClipboardPlus } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';

const EditVehicleInBuilding = (props) => {
    const { theme, locale, ModuleRP, data, setActivePage } = props;
    const [confirmDelete, setConfirmDelete] = useState(false);

    const copyClipboard = () => {
        navigator.clipboard.writeText(ModuleRP.dataVehicle.id)
            .then(() => {
                NotificationManager.success(locales[locale].notifications.copySuccess, '', 3000);
            })
            .catch(() => {
                NotificationManager.error(locales[locale].notifications.copyError, '', 3000);
            });
    };
    const updateVehicleInBuilding = () => {
        if (!_$('vehicleName').value) {
            _addClass('vehicleName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        ModuleRP.config.updateVehicleInBuilding(data.building.id, ModuleRP.dataVehicle.id, ['name', 'modelId', 'status', 'missionId', 'manning'],
            [
                _$('vehicleName').value,
                _$('vehicleType').value,
                data.listStatus.find((status) => status.system === 'ONCALL').code,
                null,
                [],
            ]);
        setActivePage('ManageBuilding');
    };

    const deleteVehicleInBuilding = () => {
        ModuleRP.config.deleteVehicleInBuilding(data.building.id, ModuleRP.dataVehicle.id);
        setActivePage('ManageBuilding');
    };

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`} id="addVehicle">
                    <h5 className="card-title">{locales[locale].config.manageVehicle}</h5>
                    <div className="row">
                        <div className="col-sm-6">
                            <h6>{locales[locale].gamesTable.vehicleName}</h6>
                            <form onSubmit={(event) => {
                                event.preventDefault();
                                () => updateVehicleInBuilding();
                            }}>
                                <input
                                    type='text'
                                    className='form-control'
                                    id='vehicleName'
                                    defaultValue={ModuleRP.dataVehicle.name}
                                    maxLength={35}
                                    onChange={(event) => ModuleRP.dataVehicle.name = event.target.value}
                                />
                                <p className="card-text text-secondary"></p>
                                <div className="card-text text-secondary">
                                    <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                        {ModuleRP.dataVehicle.id}
                                    </span>
                                    <span
                                        className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                        data-tip data-tooltip-id='copy'
                                        onClick={copyClipboard}
                                    >
                                        <BsClipboardPlus />
                                        <Tooltip id='copy' place='top' effect='solid' className='text-center'>
                                            {locales[locale].config.copyClipboard}
                                        </Tooltip>
                                    </span>
                                </div>
                            </form>
                        </div>
                        <div className="col-sm-4">
                            <h6>{locales[locale].gamesTable.vehicleType}</h6>
                            <form onSubmit={(event) => {
                                event.preventDefault();
                                () => updateVehicleInBuilding();
                            }}>
                                <select
                                    className="form-control"
                                    id="vehicleType"
                                    defaultValue={ModuleRP.dataVehicle.modelId} // Définit la valeur par défaut
                                >
                                    {data.vehicleModels && data.vehicleModels.map((vehicleModel) => (
                                        <option key={vehicleModel.id} value={vehicleModel.id}>
                                            {vehicleModel.name}
                                        </option>
                                    ))}
                                </select>
                            </form >
                        </div >
                        <div className="col-sm-2">
                            <h6>-</h6>
                            <button
                                className='btn btn-sm btn-primary float-right'
                                id='btn-updateVehicleInBuilding'
                                onClick={() => updateVehicleInBuilding()}
                            >
                                {locales[locale].config.update}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card container p-0 gameInformations mt-5 mb-2">
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <div className="row">
                        <div className="col-sm-8"></div>
                        <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                            {locales[locale].config.deleteVehicle}
                        </div>
                    </div>
                    <div className={confirmDelete ? '' : 'hide'} id="deleteBuilding">
                        <hr className={`m-1 bg-secondary`} />
                        <div>
                            {locales[locale].config.deleteConfirmVehicle}
                        </div>
                        <div className="text-center">
                            <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                {locales[locale].no}
                            </button>
                            <button
                                className='btn btn-sm btn-danger w-25 m-3'
                                id='btn-delete-vehicleInBuilding'
                                onClick={() => deleteVehicleInBuilding()}
                            >
                                {locales[locale].yes}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditVehicleInBuilding;
